import { ItemType } from 'app/components/Common/InputDropDown';
import { ar, de, enGB, es, fr, frCA, he, id, it, ja, ko, ms, nb, nl, pl, pt, ptBR, ro, ru, sv, tr, vi, zhTW } from 'date-fns/locale';

const createLocaleWithOptions = (
	locale: Locale,
	options: NonNullable<Locale['options']>
): Locale => ({
	...locale,
	options: {
		...(locale.options ?? {}),
		...options,
	},
})
export const localeMap: Record<string, Locale> = {
	'en-GB': enGB,
	'en': enGB,
	pt,
	'pt-BR': ptBR,
	es,
	de,
	fr,
	'fr-CA': frCA,
	it,
	ru,
	he,
	ar,
	sv,
	ro,
	pl,
	nl,
	tr,
	no: nb,
	id,
	ja,
	ko,
	ms,
	vi,
	'zh-TW': createLocaleWithOptions(zhTW, { weekStartsOn: 0 }),
	zh: createLocaleWithOptions(zhTW, { weekStartsOn: 0 }),
};

export const cookieCountries = ['MD', 'FR'];

// Redirect and tracking constants
export const DEFAULT_VERT = 'hotels';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_TAB = 'front';
export const DEFAULT_PROVIDER = 'kayak';
export const DEFAULT_LANG = 'en';

// Redirect timeout constants (in milliseconds)
export const REPORT_TO_SENTRY_TIMEOUT = 12000;

export const roomTypes: ItemType[] = [
	{
		label: 'main.hotels.onePerson',
		value: 'one-person',
		icon: 'icon-one-person',
	},
	{
		label: 'main.hotels.twoPerson',
		value: 'two-person',
		icon: 'icon-two-persons',
	},
	{
		label: 'main.hotels.family',
		value: 'family',
		icon: 'icon-family',
	},
];
